query RevitParameterTemplate(
    $id: ID!
) {
    revitParameterTemplate(
        id: $id
    ) {
        __typename
        id
        parameterID
        ... on RevitBuiltInParameterTemplate {
            bimClassID
            revitBuiltInParameterID
        }
        ... on RevitSharedParameterTemplate {
            revitSharedParameterDefinition {
                group
                instance
                modifiable
                type
                visible
            }
        }
    }
}
